/* global globalThis */
const redirectGuard = (meta) => meta.dispatch(redirectGuardAction(meta));

const redirectGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	if (state.auth.userType) {
		const params = new URLSearchParams(globalThis.location.search);
		const returnUrl = params.get('returnUrl');
		if (returnUrl) return returnUrl;
	}

	if (state.auth.userType === 'nonParticipant') {
		return '/home'
	}

	if (state.auth.userType === 'participant') {
		return '/dashboard'
	}

	if (state.auth.userType === 'admin') {
		return '/admin/participants'
	}

	return null
}

export { redirectGuard }
